// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer{height:60px;padding:1em;background:#0072c6;color:#fff;display:flex;justify-content:center;align-items:center;margin-top:1em}footer a{color:inherit;text-decoration:underline}footer a:hover,footer a:active,footer a:focus{color:inherit}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
